module.exports = __webpack_public_path__ + "img/sixpackcarrier52.2c62a31e.jpg";